"use client"
import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { GetPageQuery } from "apollo";
import { Article } from "lib/articles";
import { getParentsArray } from "lib/utils";
import dynamic from "next/dynamic";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import QRCodeCharge from "pazChargeComponents/Home/QRCodeCharge";
import StickyButtonNav from "pazChargeComponents/Home/SitckyButtonNavigatorCharge";
import animationData from 'public/animation/Charge_micro.json';
import { trackMoreArticlesClick } from "reusable/ChargeGTM";
import { Container, Desktop, LargeDesktop, MediumDesktop, Mobile, TitleWithLine } from "ui";
import { sharedColors } from "ui/theme/colors";
import { extractProperty } from "utils";
import ArticleContentBlockCharge from "./ArticleContentBlockCharge";
import ArticleImageHeader from "./ArticleImageHeader";
import MoreArticlesListDesktop from "./MoreArticlesListDesktop";
import MoreArticlesSwiper from "./MoreArticlesSwiper";

const StyledWrapper = styled.div`
${(props) => props.theme.breakpoints.up("lg")} {
display: grid;
grid-template-columns: 2fr 1fr;
  align-items: start;
 gap: 160px;
  }
`
const StyledContentWrapper = styled.div`
`

const StyledMoreArticles = styled.div`
width: 100%;
background-color: rgba(21, 62, 105, 0.06);
padding-left: 10px;
display: flex;
flex-direction: column;
gap: 20px;
padding-bottom: 40px;
${(props) => props.theme.breakpoints.between("md", "lg")} {
padding-top: 80px;
padding-bottom: 80px;
  align-items: start;
  }
${(props) => props.theme.breakpoints.up("lg")} {
    // flex-direction: row;
    width: 350px;
    background-color: white;
    padding: 0px;
  }
`
const StyledButton = styled(Button)`
  width: 176px;
  height: 32px;
  border-radius: 24px;
  opacity: 0px;
  background-color: ${sharedColors.blue};
  gap: 12px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 45px;
  width: 216px;
    border-radius: 40px;
  }
`
const StyledImageWrapper = styled.div`
   padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-right: 0px;
    padding-bottom: 40px;
  }
`

const TitleMoreArticle = ({ title, }: { title: string }) =>
    <TitleWithLine
        component={"h2"}
        largeDesktopFontSize={34}
        titleFontSize={34}
        mobileTitleFontSize={34}
        smallDesktopFontSize={34}
        desktopFontWeight={500}
        title={title}
        titleColor="black"
    />

// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const ButtonToUsefullInfoPage = ({ clickHandler = () => {}}: { clickHandler?: () => void }) => {
    return (
        <StyledButton variant="contained" href={'/pazcharge/useful-information'} onClick={clickHandler}>
            לכתבות נוספות
            <Lottie animationData={animationData} loop={true} style={{ marginTop: 7 }} />
        </StyledButton>
    )
}

type Props = {
    data: GetPageQuery,
    articles: Article[]
}

function ArticleDynamicPage({ data, articles }: Props) {

    const contentBlocks = extractProperty(data?.page, "pageContent")
    const headerBlocks = extractProperty(data?.page, "pageHeader")
    const moreArticlesTitle = extractProperty(data?.page, "moreArticlesTitle")
    const pageName = extractProperty(data?.page, "pageName")
    const pageHeader = extractProperty(data?.page, "pageHeader")
    const pageMainTitle = extractProperty(pageHeader[0], "pageMainTitle")
    const parents = getParentsArray(data.page, 3)
    const heroBannerDescktop = extractProperty(headerBlocks[0], "heroBannerDescktop")
    const heroBannerMobil = extractProperty(headerBlocks[0], "heroBannerMobil")

    const handleMoreArticlesClick = () => {
        trackMoreArticlesClick(pageName)
    }

    return (
        <>
            <Desktop>
                <QRCodeCharge showScrollIcon></QRCodeCharge>
            </Desktop>
            <Mobile>
                <StickyButtonNav />
                <QRCodeCharge showQRCode={false} showScrollIcon></QRCodeCharge>
            </Mobile>
            <StyledImageWrapper>
                <ArticleImageHeader desktopUrl={heroBannerDescktop} mobileUrl={heroBannerMobil} parents={parents} pageName={pageName} paddingBottom={40} />
            </StyledImageWrapper>
            <ContainerWrapper>
                <StyledWrapper>
                    <StyledContentWrapper>
                        <TitleWithLine
                            title={pageMainTitle}
                            component={"h1"}
                            titleColor="black"
                            titleFontSize={48}
                            mobileTitleFontSize={28}
                        />
                        {contentBlocks.map((block: any, index: number) => {
                            return (
                                <ArticleContentBlockCharge key={index} data={block} />
                            )
                        })}
                    </StyledContentWrapper>
                    <LargeDesktop>
                        <StyledMoreArticles>
                            <TitleMoreArticle title={moreArticlesTitle} />
                            <MoreArticlesListDesktop articles={articles} pageName={pageName} />
                            <ButtonToUsefullInfoPage clickHandler={handleMoreArticlesClick} />
                        </StyledMoreArticles>
                    </LargeDesktop>
                </StyledWrapper>
            </ContainerWrapper>
            <MediumDesktop>
                <StyledMoreArticles>
                    <ContainerWrapper>
                        <TitleMoreArticle title={moreArticlesTitle} />
                        <MoreArticlesSwiper articles={articles} arrowsAtEachSide={true} />
                        <ButtonToUsefullInfoPage clickHandler={handleMoreArticlesClick} />
                    </ContainerWrapper>
                </StyledMoreArticles>
            </MediumDesktop>
            <Mobile>
                <StyledMoreArticles>
                    <Container>
                        <TitleMoreArticle title={moreArticlesTitle} />
                        <MoreArticlesSwiper articles={articles} arrowsAtTop />
                        <ButtonToUsefullInfoPage clickHandler={handleMoreArticlesClick} />
                    </Container>
                </StyledMoreArticles>
            </Mobile>
        </>
    );
}


export default ArticleDynamicPage;
